<article
  class="page__item"
  #root
  [root]="root.nativeElement"
  (appDeferLoad)="onScroll()"
>
  <div class="box notifications">
    <header class="notifications__header">
      <h2>{{ 'NOTIFICATIONS_TAB.MAIN_TITLE' | translate }}</h2>
      <div class="settings-buttons">
        @if ((notifications$ | async)?.data?.length) {
          <button
            [disabled]="isLoading$ | async"
            class="settings-buttons__btn button button--link-blue"
            (click)="makeAllAsRead()"
          >
            <p>{{ 'NOTIFICATIONS_TAB.MARK_EVERYTHING_AS_READ' | translate }}</p>
          </button>
        }

        <button
          class="settings-buttons__btn button button--link-blue"
          (click)="openSettingsModal()"
        >
          <img src="assets/img/icons/gear_wheel.svg" alt="settings-icon" />
        </button>
      </div>
    </header>
    @if (!(isFirstLoading$ | async)) {
      @if ((notifications$ | async)?.data; as notificationItems) {
        @if (notificationItems.length) {
          @for (notification of notificationItems; track notification) {
            <section
              (click)="navigateToNotificationItem(notification.id)"
              #element
              class="notifications__item"
              [class.unread]="!notification.is_read"
            >
              @if (
                notification.template?.preview_url &&
                !fallbackImgIds.has(notification.id)
              ) {
                <img
                  [src]="notification.template.preview_url"
                  (error)="enableFallbackImg(notification.id)"
                  alt="Notification image"
                  class="image"
                />
              } @else {
                <img
                  src="assets/img/icons/no-image.svg"
                  alt="Notification fallback"
                  class="image"
                />
              }
              <div class="info-block">
                <div class="title-block">
                  <p class="title clamp-3">{{ notification?.title }}</p>
                  <p class="date">
                    {{
                      dayjs(notification?.created_at).format('DD.MM.YYYY HH:mm')
                    }}
                  </p>
                </div>
                <div class="clamp-3">
                  {{
                    notification.template?.description
                      ? notification.template?.description
                      : ('NO_DATA' | translate)
                  }}
                </div>
              </div>
            </section>
          }
          @if (isInfinityScrollLoading$ | async) {
            <ng-container [ngTemplateOutlet]="spinner"></ng-container>
          }
        } @else {
          <div class="item-placeholder text-center">
            <img
              src="./assets/img/misc/box.svg"
              alt="No messages"
              class="eye-d-none"
            />
            <p class="text-secondary">
              {{ 'NOTIFICATIONS_TAB.NO_NOTIFICATIONS' | translate }}
            </p>
          </div>
        }
      }
    } @else {
      <div class="text-secondary text-center">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="sr-only">{{ 'LOADING' | translate }}</span>
        </div>
      </div>
    }

    <ng-template #spinner>
      <div class="text-secondary text-center">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="sr-only">{{ 'LOADING' | translate }}</span>
        </div>
      </div>
    </ng-template>
  </div>
</article>
